// import { useState } from "react";
// import axios from "axios";
// import { Download, Loader2 } from "lucide-react";

// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "@/components/ui/dialog";

// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Textarea } from "@/components/ui/textarea";

// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const treatments = [
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology & Spine",
//   "Organ Transplant",
//   "Dental Care",
//   "Skin Care & Dermatology",
//   "Cosmetic Surgery",
//   "IVF & Fertility",
//   "Bariatric Surgery",
//   "Eye Care",
//   "ENT & Cochlear",
//   "Ayurveda & Wellness",
//   "Hair Transplant",
//   "Other",
// ];

// const countries = [
//   "Afghanistan",
//   "Bahrain",
//   "Bangladesh",
//   "Cameroon",
//   "Egypt",
//   "Ethiopia",
//   "Ghana",
//   "India",
//   "Indonesia",
//   "Iraq",
//   "Kenya",
//   "Kuwait",
//   "Malaysia",
//   "Mauritius",
//   "Nigeria",
//   "Oman",
//   "Pakistan",
//   "Qatar",
//   "Rwanda",
//   "Saudi Arabia",
//   "Singapore",
//   "Somalia",
//   "South Africa",
//   "Sri Lanka",
//   "Sudan",
//   "Tanzania",
//   "Thailand",
//   "UAE",
//   "Uganda",
//   "UK",
//   "USA",
//   "Vietnam",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe",
//   "Other",
// ];

// export default function DownloadBrochureModal() {
//   const [open, setOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     country: "",
//     treatment: "",
//     message: "",
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setLoading(true);

//     try {
//       await axios.post(`${API}/consultations`, form);

//       // Download brochure automatically
//       const link = document.createElement("a");
//       link.href = "/Paxgrow-Brochure.pdf";
//       link.download = "Paxgrow-Brochure.pdf";

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Close modal
//       setOpen(false);

//       // Reset form
//       setForm({
//         name: "",
//         email: "",
//         phone: "",
//         country: "",
//         treatment: "",
//         message: "",
//       });

//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog open={open} onOpenChange={setOpen}>
      
//       {/* Trigger Button */}
//       <DialogTrigger asChild>
//         <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full">
//           <Download className="h-4 w-4 mr-2" />
//           Download Brochure
//         </Button>
//       </DialogTrigger>

//       {/* Modal */}
//       <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
//         <DialogHeader>
//           <DialogTitle className="text-2xl font-bold">
//             Fill Form First
//           </DialogTitle>

//           <p className="text-sm text-slate-500">
//             Please fill consultation form to get brochure PDF.
//           </p>
//         </DialogHeader>

//         <form onSubmit={handleSubmit} className="grid gap-4 mt-4">

//           {/* Name */}
//           <div className="grid gap-2">
//             <Label>Full Name *</Label>

//             <Input
//               required
//               value={form.name}
//               onChange={(e) =>
//                 setForm({ ...form, name: e.target.value })
//               }
//               placeholder="Your full name"
//             />
//           </div>

//           {/* Email + Phone */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//             <div className="grid gap-2">
//               <Label>Email *</Label>

//               <Input
//                 type="email"
//                 required
//                 value={form.email}
//                 onChange={(e) =>
//                   setForm({ ...form, email: e.target.value })
//                 }
//                 placeholder="your@email.com"
//               />
//             </div>

//             <div className="grid gap-2">
//               <Label>Phone *</Label>

//               <Input
//                 required
//                 value={form.phone}
//                 onChange={(e) =>
//                   setForm({ ...form, phone: e.target.value })
//                 }
//                 placeholder="+91 9876543210"
//               />
//             </div>
//           </div>

//           {/* Country + Treatment */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

//             <div className="grid gap-2">
//               <Label>Country *</Label>

//               <Select
//                 onValueChange={(v) =>
//                   setForm({ ...form, country: v })
//                 }
//               >
//                 <SelectTrigger>
//                   <SelectValue placeholder="Select country" />
//                 </SelectTrigger>

//                 <SelectContent>
//                   {countries.map((c) => (
//                     <SelectItem key={c} value={c}>
//                       {c}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//             </div>

//             <div className="grid gap-2">
//               <Label>Treatment *</Label>

//               <Select
//                 onValueChange={(v) =>
//                   setForm({ ...form, treatment: v })
//                 }
//               >
//                 <SelectTrigger>
//                   <SelectValue placeholder="Select treatment" />
//                 </SelectTrigger>

//                 <SelectContent>
//                   {treatments.map((t) => (
//                     <SelectItem key={t} value={t}>
//                       {t}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>
//             </div>
//           </div>

//           {/* Message */}
//           <div className="grid gap-2">
//             <Label>Medical Details</Label>

//             <Textarea
//               rows={3}
//               value={form.message}
//               onChange={(e) =>
//                 setForm({ ...form, message: e.target.value })
//               }
//               placeholder="Briefly describe your condition..."
//             />
//           </div>

//           {/* Submit */}
//           <Button
//             type="submit"
//             disabled={loading}
//             className="bg-orange-600 hover:bg-orange-700 h-12"
//           >
//             {loading ? (
//               <>
//                 <Loader2 className="h-4 w-4 animate-spin mr-2" />
//                 Downloading...
//               </>
//             ) : (
//               <>
//                 <Download className="h-4 w-4 mr-2" />
//                 Submit & Download PDF
//               </>
//             )}
//           </Button>

//           <p className="text-xs text-center text-slate-400">
//             Please fill form first then brochure will download automatically.
//           </p>

//         </form>
//       </DialogContent>
//     </Dialog>
//   );
// // }



// import { useState } from "react";
// import axios from "axios";
// import { Download, Loader2 } from "lucide-react";

// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Textarea } from "@/components/ui/textarea";

// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const treatments = [
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology & Spine",
//   "Organ Transplant",
//   "Dental Care",
//   "Skin Care & Dermatology",
//   "Cosmetic Surgery",
//   "IVF & Fertility",
//   "Bariatric Surgery",
//   "Eye Care",
//   "ENT & Cochlear",
//   "Ayurveda & Wellness",
//   "Hair Transplant",
//   "Other",
// ];

// const countries = [
//   "Afghanistan",
//   "Bahrain",
//   "Bangladesh",
//   "Cameroon",
//   "Egypt",
//   "Ethiopia",
//   "Ghana",
//   "India",
//   "Indonesia",
//   "Iraq",
//   "Kenya",
//   "Kuwait",
//   "Malaysia",
//   "Mauritius",
//   "Nigeria",
//   "Oman",
//   "Pakistan",
//   "Qatar",
//   "Rwanda",
//   "Saudi Arabia",
//   "Singapore",
//   "Somalia",
//   "South Africa",
//   "Sri Lanka",
//   "Sudan",
//   "Tanzania",
//   "Thailand",
//   "UAE",
//   "Uganda",
//   "UK",
//   "USA",
//   "Vietnam",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe",
//   "Other",
// ];

// export default function DownloadBrochureModal() {
//   const [loading, setLoading] = useState(false);
//   const [downloadReady, setDownloadReady] = useState(false);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     country: "",
//     treatment: "",
//     message: "",
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setDownloadReady(false);

//     try {
//       await axios.post(`${API}/consultations`, form);

//       // Download brochure automatically
//       const link = document.createElement("a");
//       link.href = "/Paxgrow-Brochure.pdf";
//       link.download = "Paxgrow-Brochure.pdf";

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       setDownloadReady(true);

//       // Reset form (optional)
//       setForm({
//         name: "",
//         email: "",
//         phone: "",
//         country: "",
//         treatment: "",
//         message: "",
//       });
//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-slate-50 py-12 px-4">
//       <div className="max-w-2xl mx-auto">
//         <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8">
//           <div className="mb-6">
//             <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
//               Download Brochure
//             </h1>
//             <p className="text-sm text-slate-500 mt-2">
//               Fill the form first. After submission, the brochure PDF will download automatically.
//             </p>
//           </div>

//           <form onSubmit={handleSubmit} className="grid gap-4">
//             {/* Name */}
//             <div className="grid gap-2">
//               <Label>Full Name *</Label>
//               <Input
//                 required
//                 value={form.name}
//                 onChange={(e) => setForm({ ...form, name: e.target.value })}
//                 placeholder="Your full name"
//               />
//             </div>

//             {/* Email + Phone */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div className="grid gap-2">
//                 <Label>Email *</Label>
//                 <Input
//                   type="email"
//                   required
//                   value={form.email}
//                   onChange={(e) => setForm({ ...form, email: e.target.value })}
//                   placeholder="your@email.com"
//                 />
//               </div>

//               <div className="grid gap-2">
//                 <Label>Phone *</Label>
//                 <Input
//                   required
//                   value={form.phone}
//                   onChange={(e) => setForm({ ...form, phone: e.target.value })}
//                   placeholder="+91 9876543210"
//                 />
//               </div>
//             </div>

//             {/* Country + Treatment */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div className="grid gap-2">
//                 <Label>Country *</Label>
//                 <Select
//                   onValueChange={(v) => setForm({ ...form, country: v })}
//                 >
//                   <SelectTrigger>
//                     <SelectValue placeholder="Select country" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     {countries.map((c) => (
//                       <SelectItem key={c} value={c}>
//                         {c}
//                       </SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//               </div>

//               <div className="grid gap-2">
//                 <Label>Treatment *</Label>
//                 <Select
//                   onValueChange={(v) => setForm({ ...form, treatment: v })}
//                 >
//                   <SelectTrigger>
//                     <SelectValue placeholder="Select treatment" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     {treatments.map((t) => (
//                       <SelectItem key={t} value={t}>
//                         {t}
//                       </SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//               </div>
//             </div>

//             {/* Message */}
//             <div className="grid gap-2">
//               <Label>Medical Details</Label>
//               <Textarea
//                 rows={3}
//                 value={form.message}
//                 onChange={(e) => setForm({ ...form, message: e.target.value })}
//                 placeholder="Briefly describe your condition..."
//               />
//             </div>

//             {/* Submit */}
//             <Button
//               type="submit"
//               disabled={loading}
//               className="bg-orange-600 hover:bg-orange-700 h-12"
//             >
//               {loading ? (
//                 <>
//                   <Loader2 className="h-4 w-4 animate-spin mr-2" />
//                   Downloading...
//                 </>
//               ) : (
//                 <>
//                   <Download className="h-4 w-4 mr-2" />
//                   Submit & Download PDF
//                 </>
//               )}
//             </Button>

//             <p className="text-xs text-slate-400 text-center">
//               Please fill form first then brochure will download automatically.
//             </p>

//             {downloadReady && (
//               <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-emerald-800 text-sm">
//                 Download started. If it didn’t start automatically, use the browser download popup or try again.
//               </div>
//             )}
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DownloadBrochureModal() {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);
    try {
      const link = document.createElement("a");
      link.href = "/Paxgrow-Brochure.pdf";
      link.download = "Paxgrow-Brochure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(error);
      alert("Download failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">
            Download Our Brochure
          </h1>
          <p className="text-sm text-slate-500 mb-6">
            Click the button below to download our medical tourism brochure
          </p>

          <Button
            onClick={handleDownload}
            disabled={loading}
            className="bg-orange-600 hover:bg-orange-700 h-12 w-full sm:w-auto"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Downloading...
              </>
            ) : (
              <>
                <Download className="h-4 w-4 mr-2" />
                Download PDF
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}